var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{ref:"select",attrs:{"value":_vm.role.value,"loading":_vm.loading,"disabled":_vm.loading,"expanded":""},on:{"input":_vm.confirmChange}},_vm._l((_vm.roles),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }